<template>
  <v-card>
    <v-card-title>Contacts</v-card-title>
    <v-card-text>
      <div class="d-flex flex-column pa-2">
        <div v-for="(contact, i) in contacts" :key="`contact-${i}`"> 
          <div v-if="!contact.is_deleted" class="d-flex flex-column pb-2" >
            <v-text-field
              v-model.lazy="contact.name"
              label="Name"
              hide-details
              outlined
              dense
            >
              <template #append>
                <div class="d-flex align-center">
                  <v-btn outlined small class="mr-1" color="error" @click="softDelete(contact)">
                    Delete
                  </v-btn>
                </div>
              </template>
            </v-text-field>
          </div>
        </div>
        <div>
          <v-btn
            block
            class="elevation-0"
            outlined
            color="primary"
            @click="addContact"
          >
            Add Contact
          </v-btn>
        </div>
      </div>
      <confirm-form ref="confirmForm" />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="normal" class="mr-2" @click="close">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
  }),
  props: ['contacts'],
  methods: {
    addContact() {
      this.contacts.push({ id: null, name: '', is_deleted: 0 });
    },
    async softDelete(contact) {
      contact.is_deleted = 1;
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner
{
  margin-top: 6px;
}
</style>

